import { StoreSlice } from '..'

export interface DrawerSliceStore {
  open: boolean
  setOpen: (value: boolean) => void
  toggleOpen: (value: boolean) => void
}

export const drawerSlice: StoreSlice<DrawerSliceStore> = (set, get) => ({
  open: true,
  setOpen: (value) => {
    set({ open: value })
  },
  toggleOpen: (value) => {
    set({ open: !get().open })
  },
})
